var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BContainer',[_c('div',{staticStyle:{"margin-top":"40%"}},[_c('FrForbidden',{attrs:{"show-dashboard":false}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }